import React from 'react';

function About() {
    return (
        <div id="about" className="t473" style={{ padding: '180px 0' }}>
            <div className="t-container t-align_left">
                <div className="t-col t-col_8">
                    <div className="t473__title t-title t-name_xs">О КОМПАНИИ</div>
                    <div className="t473__descr t-descr t-descr_xxxl">
                        <p style={{ marginBottom: '30px' }}>
                            <strong>Трайтек</strong> — системный интегратор с 30‑летним опытом. Мы создаём надёжные решения для бизнеса.
                        </p>
                        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                            <li style={{ marginBottom: '20px' }}>
                                <strong> 1С – от доработок до полного сопровождения</strong><br />
                                Настраиваем, дорабатываем и интегрируем учётные системы под задачи клиента.
                            </li>
                            <li style={{ marginBottom: '20px' }}>
                                <strong> Контактная точечная сварка – ведущее направление</strong><br />
                                Проектируем и внедряем современные комплексы для промышленности.
                            </li>
                            <li style={{ marginBottom: '0' }}>
                                <strong>Более 1000 проектов</strong><br />
                                Доверие крупных предприятий, ТЭК и государственных учреждений.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;